<template>
  <div class="add">
    <header class="headet-title">
      <div class="headet-title-box">
        <p>修改密保问题</p>
        <p>您正在使用<span>“通过回答安全保护问题”</span>方式进行密保问题修改。</p>
      </div>
    </header>
    <div class="add-body">
      <el-form
        ref="questionForm"
        :model="questionForm"
        :rules="questionRules"
        label-width="130px"
        style="padding-left:40px;"
      >
        <el-form-item label="密保问题1：" prop="securityQuestionFirst">
          <el-select
            v-model="questionForm.securityQuestionFirst"
            style="width:339px;"
            disabled
          >
            <el-option
              v-for="item in questions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="密保问题答案：" prop="securityAnswerFirst">
          <el-input v-model="questionForm.securityAnswerFirst" style="width:339px" />
        </el-form-item>
        <el-form-item label="密保问题2：" prop="securityQuestionSecond">
          <el-select
            v-model="questionForm.securityQuestionSecond"
            style="width:339px;"
            disabled
          >
            <el-option
              v-for="item in questions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="密保问题答案：" prop="securityAnswerSecond">
          <el-input v-model="questionForm.securityAnswerSecond" style="width:339px" />
        </el-form-item>
        <el-form-item label="密保问题3：" prop="securityQuestionThird">
          <el-select
            v-model="questionForm.securityQuestionThird"
            style="width:339px;"
            disabled
          >
            <el-option
              v-for="item in questions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="密保问题答案：" prop="securityAnswerThird">
          <el-input v-model="questionForm.securityAnswerThird" style="width:339px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="nextCheckQuestion()">下一步</el-button>
          <el-button @click="rollback()">返回上一步</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { getEncryptData, nextCheckQuestion } from '@/api/security/encrypt'
import Session from '@/utils/session'
import { setNull } from '@/api/common/common'

export default {
  name: 'Add',
  data() {
    return {
      typeText: null,
      questionForm: {
        securityQuestionFirst: null,
        securityAnswerFirst: null,
        securityQuestionSecond: null,
        securityAnswerSecond: null,
        securityQuestionThird: null,
        securityAnswerThird: null
      },
      questionRules: {
        securityAnswerFirst: [
          {
            required: true,
            message: '请输入密保1答案，必填！',
            trigger: 'blur'
          }
        ],
        securityAnswerSecond: [
          {
            required: true,
            message: '请输入密保2答案，必填！',
            trigger: 'blur'
          }
        ],
        securityAnswerThird: [
          {
            required: true,
            message: '请输入密保3答案，必填！',
            trigger: 'blur'
          }
        ]
      },
      // 枚举--密保问题
      questions: [
        {
          value: 'aaa',
          label: '我爸爸的名字是？'
        },
        {
          value: 'bbb',
          label: '我妈妈的名字是?'
        },
        {
          value: 'ccc',
          label: '我初恋的名字是？'
        },
        {
          value: 'ddd',
          label: '我毕业的院校是？'
        },
        {
          value: 'eee',
          label: '我的出生地在哪儿？'
        },
        {
          value: 'fff',
          label: '我爸爸的名字是？'
        },
        {
          value: 'ggg',
          label: '我的生日是？'
        },
        {
          value: 'hhh',
          label: '我爸爸的生日是？'
        },
        {
          value: 'iii',
          label: '我妈妈的生日是？'
        },
        {
          value: 'jjj',
          label: '我最喜欢的城市是？'
        }
      ]
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      const otherParam = {
        // 客户id
        customerId: Session.getItem('customerId')
      }
      const param = Object.assign({}, otherParam)
      getEncryptData(param).then(res => {
        if (res.code === '0123') {
          this.$alert('您尚未设置密保问题，将为您跳转密保设置页面！', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$router.push({
                name: 'setEncrypted'
              })
            }
          })
        } else {
          this.questionForm = res.data
        }
      }).catch(error => {
        console.log(error) // 请求失败返回的数据
      })
    },
    // 返回上一步
    rollback() {
      this.$router.push({
        name: 'editEncrypted'
      })
    },
    nextCheckQuestion() {
      this.$refs['questionForm'].validate(valid => {
        if (valid) {
          const otherParam = {
            // 客户id
            customerId: Session.getItem('customerId'),
            vertifyType: '02'
          }
          const searchFormData = setNull(this.questionForm)
          const param = Object.assign({}, otherParam, searchFormData)
          nextCheckQuestion(param).then(res => {
            if (res.code === '0000' || res.code === '000000') {
              if (res.data.flag === true) {
                this.$message.success('校验成功！')
                this.$router.push({
                  name: 'setEncrypted',
                  params: {
                    type: true
                  }
                })
              }
            } else {
              this.$message.error('设置失败！' + res.message)
            }
          }).catch(error => {
            console.log(error) // 请求失败返回的数据
          })
        } else {
          console.log('error submit!!')
          return false
        }
      }
      )
    }
  }
}
</script>
<style scoped>
    .headet-title-box > p:last-of-type > span {
        color: #e50007;
    }

    .add {
        padding-bottom: 118px;
    }

    .headet-title {
        padding: 10px 30px 20px 30px;
    }

    .headet-title .headet-title-box {
        font-size: 16px;
        padding: 10px 0;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        border-bottom: 1px solid #dbdde2;
    }

    .headet-title-box {
        display: flex;
        align-items: center;
    }

    .headet-title-box > p:first-of-type {
        margin-right: 26px;
    }

    .headet-title-box > p:last-of-type {
        font-size: 14px;
        color: #a8a8a8;
    }

    .add-body ::v-deep .el-input__inner {
        height: 32px;
        font-size: 13px;
        line-height: 36px;
        border-radius: 0px;
    }

</style>
